import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./UsersUIHelpers";

const UsersUIContext = createContext();

export function useUsersUIContext() {
  return useContext(UsersUIContext);
}

export const UsersUIConsumer = UsersUIContext.Consumer;

export function UsersUIProvider({ UsersUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initUser = {
    id: undefined,
    name: "",
    email: "",
    mobileNo: "",
    role: "User",
    status: 0,
    type: 0,
    createdByName: "",
    updatedByName: "",
    createdAt: undefined,
    updatedAt: undefined
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    initUser,
    newUserButtonClick: UsersUIEvents.newUserButtonClick,
    openEditUserDialog: UsersUIEvents.openEditUserDialog,
    openDeleteUserDialog: UsersUIEvents.openDeleteUserDialog,
    openDeleteUsersDialog: UsersUIEvents.openDeleteUsersDialog,
    openFetchUsersDialog: UsersUIEvents.openFetchUsersDialog,
    openUpdateUsersStatusDialog: UsersUIEvents.openUpdateUsersStatusDialog
  };

  return (
    <UsersUIContext.Provider value={value}>{children}</UsersUIContext.Provider>
  );
}
